import React, { Component } from 'react';
import { render } from 'react-dom';
import { connect } from 'react-redux'

import { Route } from 'react-router-dom'
import Topbar from '../Topbar/'
import { getConversation, sendMessage, onAcceptVideoChatRequest, watchConversation } from './actions';
import JitsuLoader from '../JitsuLoader/';

import { v4 } from 'uuid'
import './messaging.css'

import { registerServiceWorker, askPermission } from '../../Services/service-worker-client'

import JitsuBar from '../JitsuBarOptions/jitsuBar'

const messageFlexPosision = (userId, messageData) => {

  var author = messageData.from;

  return (userId === author) ? 'justify-content-end bg-me' : 'justify-content-start bg-you'

}

class MessagingScreenComponet extends Component {
  constructor() {
    super();

    this.state = {
      draft: "",
      showLoader: false

    }
  }

  pressEnter = (event) => {

    var {messaginScreen: {id, messages}, getConversation, sendMessage} = this.props;

    if (event.keyCode == 13) {
      const {user, sendMessage} = this.props;
      const {draft} = this.state;

      sendMessage(id,
        {
          from: user.uid,
          text: draft,
          created: new Date().getTime()
        })

      this.setState({
        draft: ""
      })

    }

  }

  onInput = (event, value) => {

    this.setState({
      draft: value
    })

  }

  componentWillUnmount() {
    var {unsubscribeFromConversationWatch} = this.state;

    unsubscribeFromConversationWatch()
  }

  componentDidMount() {

    var {getConversation, watchConversation, messaginScreen: {id, messages}, locationUtil: {params: {conversationUid}}} = this.props;
    if (conversationUid || id) {

      watchConversation(conversationUid || id)

        .then((action) => {

          var {unsubscribe} = action;

          this.setState({
            unsubscribeFromConversationWatch: unsubscribe
          })

        })
      getConversation(conversationUid || id)
    }

  }

  onAcceptVideoChatRequest(messageData) {
    var {messaginScreen: {id, messages}, user, onAcceptVideoChatRequest} = this.props;
    this.setState({
      showLoader: true
    })
    onAcceptVideoChatRequest(messageData)
  }

  render() {

    var {messaginScreen: {id, messages}, user, onAcceptVideoChatRequest} = this.props;

    return (
      <div style={ { backgroundColor: 'black' } } className="h-100 d-flex flex-column">
        <Topbar/>
        <div className="flex-1 scroll-y">
          { messages
            
            && messages
            
              .map((messageData) => (
                <div className={ `w-100` } key={ v4() }>
                  <div className={ `d-flex ${messageFlexPosision(user.uid,messageData)}` }>
                    { messageData.text && <span className="basic-msg" style={ { fontSize: '4vh' } }>{ messageData.text }</span> }
                    { messageData.img && <img className="image-msg" src={ messageData.img } style={ { height: '60vh', width: '60vh' } } /> }
                    { messageData.videoChat && messageData.from != user.uid && <span onClick={ (event) => this.onAcceptVideoChatRequest(messageData) } className="video-chat-request" style={ { fontSize: '3vh' } }>video chat request</span> }
                    { messageData.videoChat && messageData.from == user.uid && <span className="video-chat-request" style={ { fontSize: '3vh' } }>sent video chat request</span> }
                  </div>
                  <div className={ `d-flex ${messageFlexPosision(user.uid,messageData)}` }>
                    <span className="time-stamp">{ new Date(messageData.created).toLocaleString() }</span>
                  </div>
                </div>
              )
            ) }
        </div>
        <JitsuBar {...{}}/>
        { id && <input value={ this.state.draft } onKeyUp={ (event) => this.pressEnter(event) } onChange={ (event) => this.onInput(event, event.target.value) } className="messaging-input" /> }
        { this.state.showLoader && <JitsuLoader/> }
      </div>
      );
  }
}

const mapStateToProps = (state, ownProps) => ({
  user: state.user,
  locationUtil: state.locationUtil,
  draft: state.draft,
  messaginScreen: state.messaginScreen
})

const MessagingScreen = connect(mapStateToProps, {
  getConversation,
  sendMessage,
  onAcceptVideoChatRequest,
  watchConversation
})(MessagingScreenComponet)

export default MessagingScreen


// WEBPACK FOOTER //
// ./src/Components/MessagingScreen/index.js